import { api } from '../api';
export default {
  link:       ()    => api.post('/v1/whatsapp/link').then(r => r.data),
  status:     ()    => api.get('/v1/whatsapp/status').then(r => r.data),
  disconnect: ()    => api.post('/v1/whatsapp/disconnect').then(r => r.data),
  qrUrl:      ()    => `${api.defaults.baseURL}/v1/whatsapp/qr?t=${Date.now()}`,
  /** Fetch the QR with the JWT attached and return an object-URL the <img> can use. */
  qrBlob: async () => {
    const resp = await api.get('/v1/whatsapp/qr', { responseType: 'blob' });
    return URL.createObjectURL(resp.data);
  },
  /** Send a WhatsApp message through the dealership's paired account. */
  send: (toPhone, content, messageType = 'TEXT') =>
    api.post('/v1/whatsapp/send', { toPhone, content, messageType }).then(r => r.data),
};
